import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'react-bootstrap/lib/Checkbox';

export default class CheckboxFilter extends React.Component {
  static propTypes = {
    filterHandler: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);
    this.filter = this.filter.bind(this);
    this.isFiltered = this.isFiltered.bind(this);
    this.inputs = {};
  }

  filter(event) {
    if (this.props.options.every((opt) => this.inputs[opt.value].checked) ||
      this.props.options.every((opt) => !this.inputs[opt.value].checked)) {
      // all or no checkboxes are checked means we want to remove the filter for this column
      this.props.filterHandler();
    } else {
      this.props.filterHandler({ callback: this.isFiltered });
    }
  }

  isFiltered(targetValue) {
    return this.inputs[targetValue].checked;
  }

  render() {
    return (
      <div>
        {this.props.options.map((opt) => <Checkbox inputRef={ref => { this.inputs[opt.value] = ref; }} key={opt.value} onChange={this.filter}>{opt.label}</Checkbox>)}
      </div>
    );
  }
}